import styles from './Footer.module.css';

import { useSiteContent } from '@/hooks/useSiteContent';

const visaIcon = new URL('../../assets/icons/visa.svg', import.meta.url).href;
const mastercardIcon = new URL('../../assets/icons/mastercard.svg', import.meta.url).href;

export const Footer = () => {
  const { content } = useSiteContent();
  const { companyDisplayName, locationBlock, linkSections } = content.footer;

  return (
    <footer className={styles.footer}>
      <div className={styles.topSection}>
        <div className={styles.companyInfo}>
          <p className={styles.companyName}>{companyDisplayName}</p>
          <p className={styles.companyDetails}>{locationBlock}</p>
          <div className={styles.paymentMethods}>
            <img src={visaIcon} alt="Visa" className={styles.paymentIcon} />
            <img src={mastercardIcon} alt="Mastercard" className={styles.paymentIcon} />
          </div>
        </div>
        {linkSections.map((section) => (
          <div className={styles.linksColumn} key={section.title}>
            <p className={styles.columnTitle}>{section.title}</p>
            <ul className={styles.linkList}>
              {section.links.map((link, linkIndex) => (
                <li key={`${section.title}-${String(linkIndex)}-${link.href}`}>
                  <a className={styles.link} href={link.href}>
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className={styles.bottomSection}>
        <p className={styles.copyright}>© 2011–2026 Alps2Alps Ltd. All rights reserved.</p>
        <p className={styles.credit}>
          Booking technology provided by{' '}
          <span className={styles.creditBrand}>SkiPasser.</span>
        </p>
      </div>
    </footer>
  );
};
